import React from "react";

import { CityConfigContext } from "../../components/CityConfigProvider";

/**
 * Hook to access the CityConfigContext value.
 *
 * @returns The CityConfigContext value.
 * @throws Will throw an error if used outside of a CityConfigContext provider.
 * @example
 * const cityConfig = useCityConfig();
 */
function useCityConfig() {
  const cityConfig = React.useContext(CityConfigContext);

  if (cityConfig === undefined) {
    throw new Error(
      "useCityConfig must be used within a CityConfigContext provider."
    );
  }

  return cityConfig;
}

export default useCityConfig;
